import React from "react";
import classes from "./StepperInputField.scss";

import PropTypes from "prop-types";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { StepperInput } from "@toddle-edu/ds-web";

import { getIsValidInput } from "Projects/modules/Utils";

class StepperInputField extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange = value => {
    const { regexString, max } = this.props;
    const isValidValue =
      (value || value === 0) &&
      regexString &&
      getIsValidInput({ value, regex: regexString, maxValue: max });

    if (isValidValue && value <= max) {
      this.updateValue(value);
    }
  };

  renderEdit = () => {
    const {
      disabled,
      value,
      name,
      placeholder,
      min,
      max,
      step,
      testId,
      error,
    } = this.props;

    return (
      <div className={classes.container}>
        <StepperInput
          min={min}
          value={value}
          onChange={this.handleChange}
          max={max}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          step={step}
          testId={testId}
          error={error}
        />
      </div>
    );
  };
}
StepperInputField.defaultProps = {
  ...UIBaseComponent.defaultProps,
  min: 0,
  max: 999.5,
  step: 0.5,
  placeholder: "-",
  error: "",
};

StepperInputField.propTypes = {
  ...UIBaseComponent.propTypes,
  min: PropTypes.number,
  max: PropTypes.number,
  placeholder: PropTypes.string,
  step: PropTypes.number,
  error: PropTypes.string,
};

export default StepperInputField;
